/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rm_Index_TitleInputs */

const en_rm_index_title = /** @type {(inputs: Rm_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Rooms`)
};

const id_rm_index_title = /** @type {(inputs: Rm_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Rancang`)
};

/**
* | output |
* | --- |
* | "Design Rooms" |
*
* @param {Rm_Index_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rm_index_title = /** @type {((inputs?: Rm_Index_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rm_Index_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rm_index_title(inputs)
	return en_rm_index_title(inputs)
});